module.exports = __webpack_public_path__ + "static/media/github-icon.3ef82ab9.png";